exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top-contents-title[data-v-6ea4170f] {\n  background-color: #eeeeee;\n  border: 1px solid black;\n}\n.top-contents-text[data-v-6ea4170f] {\n  border: 1px solid black;\n  border-left: none;\n}\n.contents-title[data-v-6ea4170f] {\n  background-color: #eeeeee;\n  border: 1px solid black;\n  border-top: none;\n}\n.contents-text[data-v-6ea4170f] {\n  border: 1px solid black;\n  border-top: none;\n  border-left: none;\n}\n.border-underline[data-v-6ea4170f] {\n  border-bottom: 1px solid black;\n}\n", ""]);

// exports
